var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-wrapper"},[_c('rc-skip-nav'),_c('rc-site-header'),_c('rc-site-content'),_c('rc-site-footer'),_c('rc-notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }